import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import { Provider } from 'react-redux'
import axios from 'axios'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { store } from './redux/store'
// ----------------------------------------------------------------------
export default function App() {
  axios.defaults.withCredentials = true
  // axios.defaults.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     if (error.response.status === 401) {
  //       localStorage.removeItem('userData')
  //       window.location.href = '/login'
  //     }
  //     return Promise.reject(error)
  //   }
  // )
  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <HelmetProvider>
          <BrowserRouter
            future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}>
            <ThemeProvider>
              <ScrollToTop />
              <StyledChart />
              <Router />
            </ThemeProvider>
          </BrowserRouter>
        </HelmetProvider>
      </LocalizationProvider>

    </Provider>
  );
}
